// ----------------------------------------------------------------------
// <copyright file="Izenda.Reports.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Reports
 */

!(function() {
  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');
  var constants = require('logic/data/Izenda.ReportsConstants');
  var ReportList = require('logic/models/Izenda.BoardList')(constants, 'reports');
  var CategoryDetail = require('logic/models/Izenda.CategoryDetail');
  const { isEmpty, remove, find } = require('lodash/fp');

  function Reports() {
    this.isLeftMenuReportLastPage = false;
    this.isLeftMenuTemplateLastPage = false;

    var props = {
      leftMenuReportCategories: [],
      leftMenuReportCategoryTree: [],
      leftMenuTemplateCategories: [],
      leftMenuTemplateCategoryTree: [],
      reportCategoryTree: [],
      copyReportCategoryList: [],
      items: new ReportList()
    };

    m.extendObservable(trackable(this), props);
    this.hasNewCategory = false;
  }

  Reports.prototype.resetCategoryStatus = function() {
    this.hasNewCategory = false;
  };

  Reports.prototype.readReportCategoryTree = m.action(function readReportCategoryTree(categoryList, reportType) {
    ensure(reportType, 'Report part type must be defined');

    categoryList = categoryList || [];

    this.reportCategoryTree = categoryList.map(function(item) {
      if (!isEmpty(item.subCategories)) {
        item.subCategories = item.subCategories.map(function(subItem) {
          return new CategoryDetail(subItem);
        });
      }
      return new CategoryDetail(item);
    });

    // add ALL REPORTS/ALL TEMPLATES category to first rows
    var allReportItem = this.createAllItem(reportType);
    this.reportCategoryTree.splice(0, 0, allReportItem);
  });

  /**
   * Read category List showed on CopyReport popup
   */
  Reports.prototype.readCopyReportCategoryList = m.action(function(categoryList) {
    categoryList = categoryList || [];

    this.copyReportCategoryList = categoryList.map(function(item) {
      if (!isEmpty(item.subCategories)) {
        item.subCategories = item.subCategories.map(function(subItem) {
          return new CategoryDetail(subItem);
        });
      }
      return new CategoryDetail(item);
    });
  });

  /**
   * Delete a ReportCategory out of reportCategoryTree
   * @param {object} reportCategory
   * @returns {promise}
   */
  Reports.prototype.removeReportCategory = m.action(function removeReportCategory(reportCategory) {
    if (!reportCategory.isSubCategory) {
      this.reportCategoryTree.replace(remove({ id: reportCategory.id }, this.reportCategoryTree));
    } else {
      var parent = find({ id: reportCategory.parentId }, this.reportCategoryTree);
      parent.subCategories.replace(remove({ id: reportCategory.id }, parent.subCategories));
    }
  });

  /**
   * reset ReportList model
   */
  Reports.prototype.resetReportList = m.action(function resetReportList() {
    this.items = new ReportList();
  });

  /**
   * create all item
   * @param {Number} reportType report Type
   * @returns {Object} all item
   */
  Reports.prototype.createAllItem = function(reportType) {
    var item = new CategoryDetail();
    var data =
      reportType.toString() === constants.CATEGORY_TYPE.REPORT
        ? constants.ALL_CATEGORY_TYPES.ALL_REPORTS
        : constants.ALL_CATEGORY_TYPES.ALL_TEMPLATES;
    item.populateData(data);
    return item;
  };

  module.exports = Reports;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Reports.js